import React from "react";
import Select from "../../components/select/Select";
import "./SectionBuilder.css";

const SectionBuilder = ({
  questionnaireState,
  handleMainDetails,
  addSection,
  handleSectionDetails,
  openCloseSections,
  errorInputs,
  errorPopUp,
  setUpDeletion,
}) => {
  return (
    <div >
      <div className="section_builder_inputs" style={{maxWidth: '600px'}}>
        <div className="items_in_row_container" style={{marginBottom: '10px'}}>
          <div
            style={{ flex: 1}}
            className={
              "sb_inp_hold" +
              (!questionnaireState.questionnaire_name && errorInputs
                ? " prog_err_input"
                : "")
            }
          >
            <div style={{width: 'calc(100% - 1rem)', margin: 0}} className="e_create_input vt_inp_included sb_inp select_main">
              <div className="select_placeholder sp_act">
                Questionnaire Name
              </div>
              <input
                type="text"
                value={
                  questionnaireState
                    ? questionnaireState.questionnaire_name
                    : ""
                }
                className={questionnaireState ? " " : "vt_input_inact"}
                onChange={(e) =>
                  handleMainDetails("questionnaire_name", e.currentTarget.value)
                }
              />
            </div>
          </div>
          <div
           style={{ flex: 1}}
            className={
              "sb_inp_hold" +
              (!questionnaireState.questionnaire_type && errorInputs
                ? " prog_err_input"
                : "")
            }
          >
            <div style={{width: 'calc(100% - 1rem)', margin: 0}} className="e_create_input vt_inp_included sb_inp select_main">
              <div className="select_placeholder sp_act">
                Questionnaire Type
              </div>
              <input
                type="text"
                value={
                  questionnaireState
                    ? questionnaireState.questionnaire_type
                    : ""
                }
                className={questionnaireState ? " " : "vt_input_inact"}
                onChange={(e) =>
                  handleMainDetails("questionnaire_type", e.currentTarget.value)
                }
              />
            </div>
          </div>
        </div>
        <div
          className={
            "sb_inp_hold" +
            (!questionnaireState.top_instructions && errorInputs
              ? " prog_err_input"
              : "")
          }
          style={{flex: 1}}
        >
          <div style={{width: 'calc(100% - 1rem)'}} className="e_create_input sb_textarea sb_inp select_main">
            <div className="select_placeholder sp_act">Top Instructions</div>
            <textarea
              type="text"
              maxLength={250}
              value={
                questionnaireState ? questionnaireState.top_instructions : ""
              }
              className={questionnaireState ? " " : "vt_input_inact"}
              onChange={(e) =>
                handleMainDetails("top_instructions", e.currentTarget.value)
              }
            />
          </div>
        </div>
        <div
          className={
            "sb_inp_hold" +
            (!questionnaireState.bottom_instructions && errorInputs
              ? " prog_err_input"
              : "")
          }
          style={{flex: 1}}
        >
          <div style={{width: 'calc(100% - 1rem)'}} className="e_create_input sb_textarea sb_inp select_main">
            <div className="select_placeholder sp_act">Bottom Instructions</div>
            <textarea
              type="text"
              maxLength={250}
              value={
                questionnaireState ? questionnaireState.bottom_instructions : ""
              }
              className={questionnaireState ? " " : "vt_input_inact"}
              onChange={(e) =>
                handleMainDetails("bottom_instructions", e.currentTarget.value)
              }
            />
          </div>
        </div>
        <div className="items_in_row_container">
        <div
          className={
            "sb_inp_hold" +
            ((!questionnaireState.related_problem && errorInputs) ||
            errorPopUp === "Related problem or subproblem was not found."
              ? " prog_err_input"
              : "")
          }
          style={{flex: 1}}
        >
          <div style={{width: 'calc(100% - 1rem)', margin: 0}} className="e_create_input vt_inp_included sb_inp select_main">
            <div className="select_placeholder sp_act">Related Problem</div>
            <input
              type="text"
              value={
                questionnaireState ? questionnaireState.related_problem : ""
              }
              className={questionnaireState ? " " : "vt_input_inact"}
              onChange={(e) =>
                handleMainDetails("related_problem", e.currentTarget.value)
              }
            />
          </div>
        </div>
        <div
          className={
            "sb_inp_hold" +
            ((!questionnaireState.related_subproblem && errorInputs) ||
            errorPopUp === "Related problem or subproblem was not found."
              ? " prog_err_input"
              : "")
          }
          style={{flex: 1}}
        >
          <div style={{width: 'calc(100% - 1rem)', margin: 0}} className="e_create_input vt_inp_included sb_inp select_main">
            <div className="select_placeholder sp_act">Related Subproblem</div>
            <input
              type="text"
              value={
                questionnaireState ? questionnaireState.related_subproblem : ""
              }
              className={questionnaireState ? " " : "vt_input_inact"}
              onChange={(e) =>
                handleMainDetails("related_subproblem", e.currentTarget.value)
              }
            />
          </div>
        </div>
        </div>
      </div>
      <div
        className={
          "virtual_hold" +
          (questionnaireState.sections.length === 0 && errorInputs
            ? " sb_sec_err"
            : "")
        }
      >
        <div className="vth_title">Sections</div>
        {questionnaireState.sections.map((section, s) => (
          <div key={s} className="vt_step_hold" style={{padding: '1rem'}}>
            <div className="items_in_row_container">
            <div
              className={
                "sb_inp_hold" +
                (section.section_number === "" && errorInputs
                  ? " prog_err_input"
                  : "")
              }
              style={{flex: 1}}
            >
              <div style={{width: 'calc(100% - 1rem)', margin: 0}} className="vt_inp_included select_main">
                <div className="select_placeholder sp_act">Section Number</div>
                <input
                  type="text"
                  value={section ? section.section_number : ""}
                  onChange={(e) =>
                    handleSectionDetails(
                      [s, "section_number"],
                      e.currentTarget.value,
                      true
                    )
                  }
                />
              </div>
            </div>
            <div
              className={
                "sb_inp_hold" +
                (!section.section_name && errorInputs ? " prog_err_input" : "")
              }
              style={{flex: 1}}
            >
              <div  style={{width: 'calc(100% - 1rem)', margin: 0}} className="vt_inp_included select_main">
                <div className="select_placeholder sp_act">Section Name</div>
                <input
                  type="text"
                  value={section ? section.section_name : ""}
                  onChange={(e) =>
                    handleSectionDetails(
                      [s, "section_name"],
                      e.currentTarget.value
                    )
                  }
                />
              </div>
            </div>
            </div>
            <div className="items_in_row_container" style={{marginTop: '10px'}}>
            <div  style={{flex: 1, width: 'calc(100%)', margin: 0}} className="vt_select_hold">
              <Select
                initVal={
                  section && section.force_newpage ? section.force_newpage : ""
                }
                placeholder="Force new page"
                selectOptions={[{ value: "Yes" }, { value: "No" }]}
                selectCallback={handleSectionDetails}
                callBackValue={[s, "force_newpage"]}
                selectError={!section.force_newpage && errorInputs}
              />
            </div>
            <div style={{flex: 1, width: 'calc(100%)', margin: 0}} className="vt_select_hold">
              <Select
              
                initVal={
                  section && section.fill_user_type
                    ? section.fill_user_type
                    : ""
                }
                placeholder="Fill User Type"
                selectOptions={[{ value: "Patient" }, { value: "Therapist" }]}
                selectCallback={handleSectionDetails}
                callBackValue={[s, "fill_user_type"]}
                selectError={!section.fill_user_type && errorInputs}
              />
            </div>
            </div>
            <div style={{margin: 0, marginTop: '10px', width: '100%'}} className="vt_select_hold">
              <Select
                initVal={
                  section && section.show_condition_question
                    ? section.show_condition_question
                    : ""
                }
                placeholder="Show condition question"
                selectOptions={[{ value: "Yes" }, { value: "No" }]}
                selectCallback={handleSectionDetails}
                callBackValue={[s, "show_condition_question"]}
                selectError={!section.show_condition_question && errorInputs}
              />
            </div>
            {section && section.show_condition_question === "Yes" && (
              <div className="vt_inp_included select_main">
                <div className="select_placeholder sp_act">
                  Show condition value
                </div>
                <input
                  type="text"
                  value={section ? section.show_condition_value : ""}
                  onChange={(e) =>
                    handleSectionDetails(
                      [s, "show_condition_value"],
                      e.currentTarget.value
                    )
                  }
                />
              </div>
            )}
            <div
              className="vt_add vt_add_left"
              onClick={() => openCloseSections(s)}
            >
              Add/Edit Questions
            </div>
            <div
              className="vt_add item_dlt_color"
              onClick={() => setUpDeletion(s, "Section", section.section_id)}
            >
              Delete Section
            </div>
          </div>
        ))}
        <div className="vt_add" onClick={() => addSection()}>
          Add Section
        </div>
      </div>
    </div>
  );
};

export default SectionBuilder;
